import { createSlice } from "@reduxjs/toolkit";
import { getCurrentYear, getCurrentMonth } from "../utils/date-utils";

const dataSummarySlice = createSlice({
  name: "dataSummary",
  initialState: {
    // QR Credit
    qrCredit: { data: [], total: 0, page: 0, itemPerPage: 25, isLoading: false, isExporting: false },
    qrCreditFilters: { filterMode: "month", year: getCurrentYear(), month: getCurrentMonth(), startDate: "", endDate: "" },

    // Scan Track
    scanTrack: { data: [], total: 0, page: 0, itemPerPage: 25, isLoading: false, isExporting: false },
    scanTrackCompanies: [],
    scanTrackBranches: [],
    scanTrackProducts: [],
    scanTrackAdditionalInfoFields: [],
    scanTrackAdditionalInfoMeta: [],
    scanTrackFilters: {
      company: "", branch: "ALL", product: "ALL",
      filterMode: "month", year: getCurrentYear(), month: getCurrentMonth(),
      startDate: "", endDate: "",
    },

    // Serial Number
    snSummary: { data: [], total: 0, page: 0, itemPerPage: 25, isLoading: false, isExporting: false },
    snCompanies: [],

    // Stockout
    stockout: { data: [], total: 0, page: 0, itemPerPage: 25, isLoading: false, isExporting: false },
    stockoutCompanies: [],

    error: null,
  },
  reducers: {
    // QR Credit
    setQrCreditData(state, action) { state.qrCredit.data = action.payload.data; state.qrCredit.total = action.payload.total; state.qrCredit.isLoading = false; },
    setQrCreditLoading(state, action) { state.qrCredit.isLoading = action.payload; if (action.payload) state.error = null; },
    setQrCreditPage(state, action) { state.qrCredit.page = action.payload; },
    setQrCreditItemPerPage(state, action) { state.qrCredit.itemPerPage = action.payload; state.qrCredit.page = 0; },
    setQrCreditFilters(state, action) { Object.assign(state.qrCreditFilters, action.payload); state.qrCredit.page = 0; },
    setQrCreditExporting(state, action) { state.qrCredit.isExporting = action.payload; },
    resetQrCreditFilters(state) { state.qrCreditFilters = { filterMode: "month", year: getCurrentYear(), month: getCurrentMonth(), startDate: "", endDate: "" }; state.qrCredit.page = 0; },

    // Scan Track
    setScanTrackData(state, action) { state.scanTrack.data = action.payload.data; state.scanTrack.total = action.payload.total; state.scanTrackAdditionalInfoMeta = action.payload.additionalInfoMeta || []; state.scanTrack.isLoading = false; },
    setScanTrackLoading(state, action) { state.scanTrack.isLoading = action.payload; if (action.payload) state.error = null; },
    setScanTrackPage(state, action) { state.scanTrack.page = action.payload; },
    setScanTrackItemPerPage(state, action) { state.scanTrack.itemPerPage = action.payload; state.scanTrack.page = 0; },
    setScanTrackCompanies(state, action) { state.scanTrackCompanies = action.payload; },
    setScanTrackBranches(state, action) { state.scanTrackBranches = action.payload; },
    setScanTrackProducts(state, action) { state.scanTrackProducts = action.payload; },
    setScanTrackAdditionalInfoFields(state, action) { state.scanTrackAdditionalInfoFields = action.payload; },
    setScanTrackFilters(state, action) { Object.assign(state.scanTrackFilters, action.payload); state.scanTrack.page = 0; },
    setScanTrackExporting(state, action) { state.scanTrack.isExporting = action.payload; },

    // SN Summary
    setSnData(state, action) { state.snSummary.data = action.payload.data; state.snSummary.total = action.payload.total; state.snSummary.isLoading = false; },
    setSnLoading(state, action) { state.snSummary.isLoading = action.payload; if (action.payload) state.error = null; },
    setSnPage(state, action) { state.snSummary.page = action.payload; },
    setSnItemPerPage(state, action) { state.snSummary.itemPerPage = action.payload; state.snSummary.page = 0; },
    setSnCompanies(state, action) { state.snCompanies = action.payload; },
    setSnExporting(state, action) { state.snSummary.isExporting = action.payload; },

    // Stockout
    setStockoutData(state, action) { state.stockout.data = action.payload.data; state.stockout.total = action.payload.total; state.stockout.isLoading = false; },
    setStockoutLoading(state, action) { state.stockout.isLoading = action.payload; if (action.payload) state.error = null; },
    setStockoutPage(state, action) { state.stockout.page = action.payload; },
    setStockoutItemPerPage(state, action) { state.stockout.itemPerPage = action.payload; state.stockout.page = 0; },
    setStockoutCompanies(state, action) { state.stockoutCompanies = action.payload; },
    setStockoutExporting(state, action) { state.stockout.isExporting = action.payload; },

    setError(state, action) { state.error = action.payload; },
  },
});

export const {
  setQrCreditData, setQrCreditLoading, setQrCreditPage, setQrCreditItemPerPage, setQrCreditFilters, setQrCreditExporting, resetQrCreditFilters,
  setScanTrackData, setScanTrackLoading, setScanTrackPage, setScanTrackItemPerPage, setScanTrackCompanies, setScanTrackBranches, setScanTrackProducts, setScanTrackAdditionalInfoFields, setScanTrackFilters, setScanTrackExporting,
  setSnData, setSnLoading, setSnPage, setSnItemPerPage, setSnCompanies, setSnExporting,
  setStockoutData, setStockoutLoading, setStockoutPage, setStockoutItemPerPage, setStockoutCompanies, setStockoutExporting,
  setError,
} = dataSummarySlice.actions;
export default dataSummarySlice.reducer;
